<template>
  <div class="personnel-on-duty-classes-modify">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次名称：</span>
        </div>
        <el-input v-model="formData.routeName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">班次描述：</span>
        </div>
        <el-input v-model="formData.description" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班次时间：</span>
        </div>
        <time-interval :defaultLineIndex="defaultLineIndex" @getAttendanceItemDurations="getTimeArr" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">班次备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import md5 from 'js-md5'
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../../components/Text/TextTitle'
import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../../utils/errorHandler'
import {api} from '../../../api/ParkingService'
import {nError, nSuccess} from '../../../../utils/notice'
import {pattern} from '../../../../utils/regular'
import TimeInterval from "../../../../components/WeekTime/timeInterval";

export default {
  components: {
    TimeInterval,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'personnel-on-duty-classes-modify',
  data () {
    return {
      breadcrumb: [
        {value: '智慧停车', name: 'parking-device-management'},
        {value: '班次管理'}
      ],
      mainTitle: '修改班次',
      subheading: '',

      defaultLineIndex: [],
      formData: {
        routeName: '',
        description: '',
        monTimes: [],
        tueTimes: [],
        wedTimes: [],
        thuTimes: [],
        friTimes: [],
        satTimes: [],
        sunTimes: [],
        memo: '',
      }
    }
  },
  created () {
    this.getParkingEmergencyRouteByCode()
  },
  methods: {
    toMangePage () {
      this.$router.push({
        name: 'personnel-on-duty-classes-manage'
      })
    },

    // 获取信息
    getParkingEmergencyRouteByCode () {
      this.$axios.get(`${api.getParkingEmergencyRouteByCode}/${this.$route.params.id}`, {})
        .then(res => {
          let data = res.data.data

          data.attendanceItemDurations = [
            {
              segments: data.monTimes,
              weekType: '1'
            }, {
              segments: data.tueTimes,
              weekType: '2'
            }, {
              segments: data.wedTimes,
              weekType: '3'
            }, {
              segments: data.thuTimes,
              weekType: '4'
            }, {
              segments: data.friTimes,
              weekType: '5'
            }, {
              segments: data.satTimes,
              weekType: '6'
            }, {
              segments: data.sunTimes,
              weekType: '7'
            }
          ]

          let timePlanArr = []
          for (let h = 0; h < data.attendanceItemDurations.length; h++) {
            let obj = {
              weekDay: [],
              week: [
                {
                  key: '周一',
                  disabled: false
                },
                {
                  key: '周二',
                  disabled: false
                },
                {
                  key: '周三',
                  disabled: false
                },
                {
                  key: '周四',
                  disabled: false
                },
                {
                  key: '周五',
                  disabled: false
                },
                {
                  key: '周六',
                  disabled: false
                },
                {
                  key: '周日',
                  disabled: false
                }
              ],
              weekTimeValue: [],
            }
            for (let k = 0; k < data.attendanceItemDurations.length; k++) {
              if (data.attendanceItemDurations[h].segments.length > 0) {
                data.attendanceItemDurations[h].segments.map(hv => {
                  data.attendanceItemDurations[k].segments.map(kv => {
                    if (`${hv.startTime}${hv.endTime}` === `${kv.startTime}${kv.endTime}`) {
                      if (data.attendanceItemDurations[h].weekType === '1' || data.attendanceItemDurations[k].weekType === '1') {
                        if (obj.weekDay.indexOf('周一') === -1) {
                          obj.weekDay.push('周一')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '2' || data.attendanceItemDurations[k].weekType === '2') {
                        if (obj.weekDay.indexOf('周二') === -1) {
                          obj.weekDay.push('周二')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '3' || data.attendanceItemDurations[k].weekType === '3') {
                        if (obj.weekDay.indexOf('周三') === -1) {
                          obj.weekDay.push('周三')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '4' || data.attendanceItemDurations[k].weekType === '4') {
                        if (obj.weekDay.indexOf('周四') === -1) {
                          obj.weekDay.push('周四')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '5' || data.attendanceItemDurations[k].weekType === '5') {
                        if (obj.weekDay.indexOf('周五') === -1) {
                          obj.weekDay.push('周五')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '6' || data.attendanceItemDurations[k].weekType === '6') {
                        if (obj.weekDay.indexOf('周六') === -1) {
                          obj.weekDay.push('周六')
                        }
                      }
                      if (data.attendanceItemDurations[h].weekType === '7' || data.attendanceItemDurations[k].weekType === '7') {
                        if (obj.weekDay.indexOf('周日') === -1) {
                          obj.weekDay.push('周日')
                        }
                      }
                      if (obj.weekTimeValue.length === 0) {
                        let timeValueObj = {
                          key: [hv.startTime, hv.endTime]
                        }
                        obj.weekTimeValue.push(timeValueObj)
                      } else {
                        let oldWeekTimeValue = []
                        obj.weekTimeValue.map(weekTimeValue => {
                          oldWeekTimeValue.push(`${weekTimeValue.key[0]}${weekTimeValue.key[1]}`)
                        })
                        if (oldWeekTimeValue.indexOf(`${hv.startTime}${hv.endTime}`) === -1) {
                          obj.weekTimeValue.push({
                            key: [hv.startTime, hv.endTime]
                          })
                        }
                      }
                      if (timePlanArr.length === 0) {
                        timePlanArr.push(obj)
                      } else {
                        timePlanArr.push(obj)
                      }
                    }
                  })
                })
              }
            }
          }

          this.defaultLineIndex = timePlanArr

          this.formData = data
        })
        .catch(errorHandler('获取信息失败'))
    },

    getTimeArr (data) {
      this.formData.monTimes = []
      this.formData.tueTimes = []
      this.formData.wedTimes = []
      this.formData.thuTimes = []
      this.formData.friTimes = []
      this.formData.satTimes = []
      this.formData.sunTimes = []
      data.map(v => {
        if (v.weekDay.length > 0) {
          v.weekDay.map(weekDay => {
            if (weekDay === '周一') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.monTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.monTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周二') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.tueTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.tueTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周三') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.wedTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.wedTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周四') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.thuTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.thuTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周五') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.friTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.friTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周六') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.satTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.satTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
            if (weekDay === '周日') {
              v.weekTimeValue.map(weekTimeValue => {
                let startTime = weekTimeValue.key[0]
                let endTime = weekTimeValue.key[1]
                let isInSegments = false
                this.formData.sunTimes.map(segments => {
                  if (`${segments.startTime},${segments.endTime}` === `${startTime},${endTime}`) {
                    isInSegments = true
                  }
                })
                if (!isInSegments && startTime && endTime) {
                  this.formData.sunTimes.push({
                    startTime,
                    endTime
                  })
                }
              })
            }
          })
        }
      })
    },

    confirm () {
      this.$axios.post(api.updateParkingEmergencyRoute, this.formData)
        .then(res => {
          nSuccess('修改成功')
          this.toMangePage()
        })
        .catch(errorHandler('修改失败'))
    },
    cancel () {
      this.toMangePage()
    }
  },
}
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #FF0000;
  vertical-align: -webkit-baseline-middle;
}
.form-line {
  margin: 20px 0;
}
.line-text{
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.dialogLine {
  width: 60%;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.dialogLine div {
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/PersonnelOnDuty/PersonnelOnDutyClasses/PersonnelOnDutyClassesModify.vue